import { tv } from "tailwind-variants";

const alertStyles = tv({
  base: "rounded-lg border px-4 py-3 text-sm font-medium",
  variants: {
    variant: {
      error: "border-danger/50 bg-danger/15 text-danger-subtle-fg",
      success: "border-success/50 bg-success/15 text-success-subtle-fg",
      info: "border-accent/50 bg-accent/15 text-accent-fg",
    },
  },
  defaultVariants: {
    variant: "info",
  },
});

export interface AlertProps {
  variant?: "error" | "success" | "info";
  children: React.ReactNode;
  className?: string;
}

export function Alert({ variant, children, className }: AlertProps) {
  return (
    <div role="alert" className={alertStyles({ variant, className })}>
      {children}
    </div>
  );
}
